import classNames from 'classnames';

export type TextElementProps = {
    className?: string;
} & ({ rawHtml?: string | null; children?: never } | { rawHtml?: never; children?: React.ReactNode });

export const TextElement = ({ className, rawHtml, children }: TextElementProps) =>
    rawHtml ? (
        <div className={classNames('text-element', className)} dangerouslySetInnerHTML={{ __html: rawHtml }} />
    ) : (
        <div className={classNames('text-element', className)}>{children}</div>
    );
